export default __webpack_public_path__ + "static/media/HeroImageHome.a2406da9.png";